export default "__VITE_ASSET__D$Fxxchr__"